import { Box, CircularProgress, Input, Table } from "@mui/joy";
import React from "react";
import { Util } from "../Helpers/Util";

interface CheckInRecord {
	full_name: string;
	check_in_date: string;
	building_name: string;
}

export default function CheckedInTracker() {
	const [checkIn, setCheckIn] = React.useState<Array<CheckInRecord>>();
	const [nameFilter, setNameFilter] = React.useState("");
	const [bldFilter, setBldFilter] = React.useState("");
	React.useEffect(() => getData(), []);

	const getData = () => {
		fetch("User/GetCheckedInUsers")
			.then((x) => x.json())
			.then((x) => {
				console.log(x);
				setCheckIn(x);
			});
	};

	const renderGrid = () => {
		const rows = checkIn?.filter((x) => Util.isNullOrEmpty(nameFilter) || x.full_name.toLowerCase().includes(nameFilter.toLowerCase())).filter((x) => Util.isNullOrEmpty(bldFilter) || x.building_name.toLowerCase().includes(bldFilter.toLowerCase()));
		return (
			<Table stripe="even">
				<thead>
					<tr>
						<th>
							<div style={{ display: "flex" }}>
								<span style={{ paddingRight: "8px", paddingTop: "4px" }}>Mechanic</span>
								<Input size="sm" value={nameFilter} onChange={(event) => setNameFilter(event.target.value)} placeholder="Search" />
							</div>
						</th>
						<th>
							<div style={{ display: "flex" }}>
								<span style={{ paddingRight: "8px", paddingTop: "4px" }}>Building</span>
								<Input size="sm" value={bldFilter} onChange={(event) => setBldFilter(event.target.value)} placeholder="Search" />
							</div>
						</th>
						<th>Check In/Out Time</th>
					</tr>
				</thead>
				<tbody>
					{rows?.map((x) => {
						return (
							<tr>
								<td>{x.full_name}</td>
								<td>{x.building_name}</td>
								<td>{Util.Formatter(x.check_in_date, "DT")}</td>
							</tr>
						);
					})}
				</tbody>
			</Table>
		);
	};

	return checkIn ? (
		renderGrid()
	) : (
		<Box sx={{ display: "flex", justifyContent: "center" }}>
			<CircularProgress />
		</Box>
	);
}
